import sendReportRequest from './sendReportRequest';

const fetchReportSalesByTable = async ({ dateRange, from, to, reportingType }) => {
  const reponseData = await sendReportRequest({
    url: '/reports/salesByTable',
    dateRange,
    from,
    to,
    reportingType,
  });

  return reponseData;
};

export default fetchReportSalesByTable;
